import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator'
import { initialLocalAutomationValuableConceptsModalBasicFormState, LocalAutomationValuableConceptsModalBasicFormState } from '@/modules/configurationModule/detail/automation/valuable-concepts/components/valuable-concepts-modal-basic-form/configuration-valuable-concepts-modal-basic-form.model'
import { ConfigurationOntologyForAutomaticValuableConceptCreateRequest, ConfigurationOntologyForAutomaticValuableConceptResponse } from '@/modules/configurationModule/detail/automation/valuable-concepts/services/configuration-valuable-concepts.dto'
import { commonSampleClassificationService } from '@/api/resources/common/sample-classification/sample-classification.service'
import { CommonSampleTypeResponse } from '@/api/services/common/sample-type/common-sample-type.dto'
import { CommonTopographicCodeResponse } from '@/api/services/common/topographic-code/common-topographic-code.dto'
import { CommonProcedureResponse } from '@/api/services/common/procedure/common-procedure.dto'
import { CommonMostLikelyMorphologicCodeResponse } from '@/api/services/common/most-likely-morphologic-code/common-most-likely-morphologic-code.dto'

@Component
export default class ValuableConceptsModalBasicForm extends Vue {
    @Prop() readonly selectedRow!: ConfigurationOntologyForAutomaticValuableConceptResponse
    @Prop() readonly laboratoryId!: number
    @Prop() readonly actionTitle!: string

    @Emit()
    create(): ConfigurationOntologyForAutomaticValuableConceptCreateRequest {
        return {
            sampleTypeId: this.state.sampleType?.id!,
            mostLikelyMorphologicCodeId: this.state.mostLikelyMorphologicCode?.id,
            procedureId: this.state.procedure?.id,
            topographicCodeId: this.state.topographicCode?.id
        }
    }

    @Watch('selectedRow', { immediate: true, deep: true })
    async onSelectedRowChanged(val: ConfigurationOntologyForAutomaticValuableConceptResponse) {
        if (val) {
            this.state = {
                ...this.state,
                sampleType: val?.sampleType,
                mostLikelyMorphologicCode: val?.mostLikelyMorphologicCode,
                procedure: val?.procedure,
                topographicCode: val?.topographicCode
            }
        }
    }

    state: LocalAutomationValuableConceptsModalBasicFormState
    constructor() {
        super()
        this.state = initialLocalAutomationValuableConceptsModalBasicFormState()
    }

    get canUpdate(): boolean {
        const someFieldIsDirty = this.$_someFieldIsDirty(this.fields)
        const errors = this.errors.count()
        const sampleTypeRequired = !!this.state.sampleType?.id
        return someFieldIsDirty && !errors && sampleTypeRequired
    }

    get canUpdateCombo(): boolean {
        return !this.selectedRow?.id
    }

    get canSelectProcedure(): boolean {
        return !!this.state.topographicCode?.id
    }

    get canSelectMostLikelyMorphologicCode(): boolean {
        return !!this.state.procedure?.id
    }

    getCommonSampleTypes(): Promise<CommonSampleTypeResponse[]> {
        return commonSampleClassificationService.getCommonSampleTypeSampleClassificationsByLaboratory({ laboratoryId: this.laboratoryId })
    }

    getCommonTopographicCodes(): Promise<CommonTopographicCodeResponse[]> {
        return commonSampleClassificationService.getCommonTopographicCodesSampleClassificationsByLaboratory({ laboratoryId: this.laboratoryId })
    }

    getCommonProcedures(): Promise<CommonProcedureResponse[]> {
        return commonSampleClassificationService.getCommonProceduresSampleClassificationsByLaboratory({ laboratoryId: this.laboratoryId })
    }

    getCommonMostLikelyMorphologicCodeTypes(): Promise<CommonMostLikelyMorphologicCodeResponse[]> {
        return commonSampleClassificationService.getCommonMostLikelyMorphologicCodesSampleClassificationsByLaboratory({ laboratoryId: this.laboratoryId })
    }
}
